import seo from './pageMeta.json'

interface RouteMeta {
  title: string
  description: string
  changefreq: string
  priority: number
}

// Single source of truth for static public-route meta. Pages consume it via
// usePageMeta(pageMeta('/route')); scripts/prerender.mjs reads the same JSON at
// build time to write per-route <head> tags and the sitemap — keep them in sync
// by only ever editing pageMeta.json.
const routes = seo.routes as Record<string, RouteMeta>

export interface ResolvedMeta {
  title: string
  description: string
  path: string
}

export function pageMeta(path: string): ResolvedMeta {
  const meta = routes[path]
  return { title: meta.title, description: meta.description, path }
}

/**
 * Like pageMeta, but returns null for paths with no hand-written meta. Used by
 * pages that serve both curated routes and dynamic ones — /packages/factory-cli
 * has tuned SEO meta, /packages/some-user-package does not.
 */
export function tryPageMeta(path: string): ResolvedMeta | null {
  return routes[path] ? pageMeta(path) : null
}
